"use client";

import Link from "next/link";
import React, { type ReactElement } from "react";
import Image from "next/image";
import { FooterOrganization } from "@/services/organisations";
import { cva } from "class-variance-authority";
import { cn } from "@oreme/ui";

interface OrganizationListItemProps extends React.ComponentProps<"li"> {
  organization: FooterOrganization;
}

const listItemVariants = cva("grow-0");

function OrganizationListItem({
  organization,
  className,
}: Readonly<OrganizationListItemProps>): ReactElement | null {
  return (
    <li key={organization.id} className={cn(listItemVariants(), className)}>
      {organization.url ? (
        <Link href={organization.url} target="_blank" rel="nofollow">
          <Image
            className="w-auto max-h-16"
            src={`/images/${organization.picture}`}
            alt={organization.name}
            width={organization.size?.width}
            height={organization.size?.height}
            sizes="96px"
            priority
          />
        </Link>
      ) : (
        <Image
          className="w-auto max-h-16"
          src={`/images/${organization.picture}`}
          alt={organization.name}
          width={organization.size?.width}
          height={organization.size?.height}
          sizes="96px"
          priority
        />
      )}
    </li>
  );
}

export { OrganizationListItem, type OrganizationListItemProps };
